export const API_URL = process.env.REACT_APP_API_URL || "/";
export const APP_NAME = process.env.REACT_APP_NAME || "Eprofile";